import { render, staticRenderFns } from "./Smarttrade.vue?vue&type=template&id=74bd4b69"
import script from "./Smarttrade.vue?vue&type=script&lang=js"
export * from "./Smarttrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports